<script setup>
import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant'
import misc404 from '@images/pages/404.png'
import miscMaskDark from '@images/pages/misc-mask-dark.png'
import miscMaskLight from '@images/pages/misc-mask-light.png'

const authThemeMask = useGenerateImageVariant(miscMaskLight, miscMaskDark)

definePage({
  alias: '/pages/misc/not-found/:error(.*)',
  meta: {
    layout: 'blank',
    public: true,
  },
})
</script>

<template>
  <ErrorHeader
    :status-code="404"
    :title="$gettext('Page Not Found') + ' ⚠️'"
    :description="$gettext('We couldn\'t find the page you are looking for.')"
  />

  <VBtn
    to="/"
    class="mb-12"
  >
    {{ $gettext("Back to Home") }}
  </VBtn>

  <!-- 👉 Image -->
  <div class="misc-avatar w-100 text-center">
    <VImg
      :src="misc404"
      :alt="$gettext('Coming Soon')"
      :max-width="200"
      class="mx-auto"
    />
  </div>

  <VImg
    :src="authThemeMask"
    class="misc-footer-img d-none d-md-block"
  />
</template>

<style lang="scss">
@use "@core/scss/template/pages/misc.scss";
</style>
